import { EmbryoService } from "../../../Services/Embryo.service";
import { CheckoutService } from "../../../Services/checkout.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { Component, Inject } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { IframeModalComponent } from "../iframe-modal/iframe-modal.component";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

@Component({
    selector: "checkout-accept-dialog",
    templateUrl: "./checkout-accept-dialog.component.html",
    styleUrls: ["./checkout-accept-dialog.component.css"],
})
export class CheckoutAcceptDialog {
    verifyForm!: FormGroup;
    lang: any;
    phoneForm!: FormGroup;
    phoneSuccessflly: boolean = false;
    user: any;
    isSubmiting = false;
    constructor(
        private formBuilder: FormBuilder,
        private auth: LoginUsersService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CheckoutAcceptDialog>,
        public snackBar: MatSnackBar,
        private checkoutService: CheckoutService,
        private translate: TranslateService,
        public router: Router,
        private embryoService: EmbryoService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
    }

    acceptPayment() {
        this.data.accept_payment_discount_dialog = true;
        this.isSubmiting = true;
        // if (this.data.selectedDeliveryType == 1 && this.data.branch_id) {
        //     delete this.data.address_id;
        // }
        this.checkoutService.placeOrder(this.data).subscribe(
            (response: any) => {
                this.isSubmiting = false;
                if (response.code === 200 || response.code === 201) {
                    this.dialogRef.close();
                    this.embryoService.productCartSub.next([]);
                    this.embryoService.getProductCart();

                    this.router
                        .navigate([
                            this.lang + "/checkout/final-receipt",
                            response.data.uuid
                                ? response.data.uuid
                                : response.data.id,
                        ])
                        .then(() => {});
                } else if (response.code === 202) {
                    this.dialogRef.close();
                    localStorage.setItem("pay_url", response.data.pay_url);
                    // window.location.href = response.data.pay_url;
                    const dialogRef = this.dialog.open(IframeModalComponent, {
                        width: "500px",
                        data: response.data.pay_url,
                    });
                } else if (response.code == 203) {
                    this.dialogRef.close();
                    localStorage.setItem("pay_url", response.data.pay_url);
                    window.open(response.data.pay_url, "_self");
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${response.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            },
            (err) => {
                this.isSubmiting = false;
            }
        );
    }

    cancelPayment() {
        this.dialogRef.close();
    }
}
